/* eslint-disable no-confusing-arrow */
import classNames from "classnames";
import AccessBarBtn from "pages/_components/AccessBarBtn";
import Box from "pages/_components/Box";
import Button from "pages/_components/Button";
import Text from "pages/_components/Text";
import { arrayOf, bool, shape, string } from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { selectors as sessionSelectors } from "reducers/session";
import { selectors as transactionsSelectors } from "reducers/transactions";
import { getUrlMarket } from "util/settings";

const AccessBar = ({ options, defaultAccesBar, accessButton, isActiveCorporate }) =>
    defaultAccesBar ? (
        <Box className="access-bar-wrapper" component="nav" display="flex" alignX="between" alignY="center">
            <Box className="access-bar" display="flex">
                {options.map((option, index) =>
                    index === 1 ? (
                        <>
                            <Box display="flex">
                                <Button
                                    ariaLabel={accessButton.label}
                                    className={classNames("banesco-btn my-auto", {
                                        "banesco-btn-is-corporate": isActiveCorporate,
                                    })}
                                    {...(accessButton.href && { href: accessButton.href })}
                                    {...(accessButton.onClick && { onClick: accessButton.onClick })}
                                    image={accessButton.image}
                                    imageMd
                                    disabled={!accessButton.href && !accessButton.onClick}
                                />
                            </Box>
                            <AccessBarBtn
                                key={`${option.label}_${option.image}`}
                                image={option.image}
                                label={option.label}
                                className={option.className}
                                href={option.href}
                                externalHref={option.externalHref}
                                onClick={option.onClick}
                            />
                        </>
                    ) : (
                        <AccessBarBtn
                            key={`${option.label}_${option.image}`}
                            image={option.image}
                            label={option.label}
                            className={option.className}
                            href={option.href}
                            externalHref={option.externalHref}
                            onClick={option.onClick}
                        />
                    ),
                )}
            </Box>
        </Box>
    ) : (
        <Box
            className="access-bar-wrapper access-bar-wrapper-blue"
            component="article"
            display="flex"
            alignX="between"
            alignY="center">
            <Box display="flex" column className="pr-5">
                <Text labelKey="login.access.app.title" size="small" color="inverse" className="pb-2" />
            </Box>
            <Button
                externalHref={getUrlMarket()}
                label="login.access.app.btn"
                bsStyle="outline"
                className="access-bar-app-btn"
                inverse
            />
        </Box>
    );

AccessBar.propTypes = {
    options: arrayOf(
        shape({
            image: string,
            href: string,
            label: string,
            className: string,
        }),
    ).isRequired,

    accessButton: shape({}),
    defaultAccesBar: bool,
    isLocal: bool,
    isActiveCorporate: bool.isRequired,
    isExternalLayout: bool,
};

AccessBar.defaultProps = {
    accessButton: null,
    defaultAccesBar: true,
    isLocal: false,
    isExternalLayout: false,
};

const mapStateToProps = (state) => ({
    pendingTransactionsQuantity: transactionsSelectors.getPendingTransactionsQuantity(state),
    isActiveCorporate: sessionSelectors.isActiveCorporate(state),
});

export default connect(mapStateToProps)(AccessBar);
